var lang;
var shopName;

function baseShopVars() {
  var host = location.hostname;

  // Production hostnames (public — safe to ship in the bundle).
  if (host.match('wilsondo.sk')) {
    shopName = "wsk";
    lang = "sk";
  } else if (host.match('wilsondo.hu')) {
    shopName = "whu";
    lang = "hu";
  } else if (host.match('wilsondo.cz')) {
    shopName = "wcz";
    lang = "cs";
  } else if (host.match('wilsondo.ro')) {
    shopName = "wro";
    lang = "ro";
  } else if (host.match('wilsondo.bg')) {
    shopName = "wbg";
    lang = "bg";
  } else if (host.match('wilsondo.hr')) {
    shopName = "whr";
    lang = "hr";
  } else if (host.match('wilsondo.si')) {
    shopName = "wsi";
    lang = "sl";
  } else if (host.match('wilsondo.ua')) {
    shopName = "wua";
    lang = "uk";
  } else if (host.match('detskapostel.com')) {
    shopName = "dpc";
    lang = "sk";
  } else if (host.match('matrac-es-en.hu')) {
    shopName = "mee";
    lang = "hu";
  } else if (host.match('ja-a-matrac.sk')) {
    shopName = "jam";
    lang = "sk";
  } else if (host.match('morningo.cz')) {
    shopName = "mcz";
    lang = "cs";
  } else if (host.match('morningo.hr')) {
    shopName = "mhr";
    lang = "hr";
  } else if (host.match('emeletes-agyak.hu')) {
    shopName = "eag";
    lang = "hu";
  } else if (host.match('poschodovky.sk')) {
    shopName = "pos";
    lang = "sk";
  } else if (host.match('localhost') || host.match('127.0.0.1')) {
    // Dev server via BrowserSync proxy. Gulp injects the active shop from
    // config/shops.config.json into dev/js/__dev-shop.generated.js.
    shopName = (typeof window !== "undefined" && window.__DEV_SHOP__) || "wsk";
    lang    = (typeof window !== "undefined" && window.__DEV_LANG__) || "sk";
  }

  // Unique, shop-specific <body> class so CSS can target a single e-shop
  // without risking an id/class collision on another store. The `shop-`
  // prefix keeps it clear of bare shop classes already used in SCSS
  // (e.g. `.detskapostel`, `.poschodovky`) and of the shared `.wilsondo`
  // theme class. Result: shop-wsk, shop-jam, shop-dpc, shop-pos, …
  if (shopName && typeof document !== "undefined" && document.body) {
    document.body.classList.add("shop-" + shopName);
  }

  switch (shopName) {
    case 'wsk':
      // code block
      break;
    case 'whu':
      // code block
      break;
    case 'wcz':
      // code block
      break;
    case 'wro':
      // code block
      break;
    case 'wbg':
      // code block
      break;
    case 'whr':
      // code block
      break;
    case 'wsi':
      // code block
      break;
    case 'wua':
      // code block
      break;
  }

  switch (lang) {
    case 'sk':
      // code block
      break;
    case 'hu':
      // code block
      break;
    case 'cs':
      // code block
      break;
    case 'ro':
      // code block
      break;
    case 'bg':
      // code block
      break;
    case 'hr':
      // code block
      break;
    case 'sl':
      // code block
      break;
    case 'uk':
      // code block
      break;
  }
}
